import React from "react";
import { Label, Segment, Popup, Button } from "semantic-ui-react";

export const StatsBox = props => {
  return (
    <Segment>
      <Label color="red" ribbon>
        {props.label}
      </Label>
      <span
        style={{
          display: "block",
          fontSize: "1.8em",
          marginTop: "0.4em",
          textAlign: "center"
        }}
      >
        {props.value}
      </span>

      {props.shopifyPendingOrders > 0 && (
        <Popup
          trigger={<Button 
                    content='Show Pending Orders' 
                    style={{marginTop: "10px"}} 
                    onClick={props.onShowPendingOrdersClick}
                    />}
          content={props.renderPopupContent()}
          on='click'
          position='top right'
        />
      )}
    </Segment>
  );
};
